import React, { useEffect, useRef, useState } from "react";
import { ModelWrapperWithButton } from "../../component/ModelWrapperWithButton";
import PasswordChange from "./models/PasswordChange";
import ChangePhone from "./models/ChangePhone";
import { toAbsoluteUrl } from "sr/helpers";
import { FormattedMessage, useIntl } from "react-intl";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { useGet } from "app/pages/company/Hooks/Api/useGet";
import { getIndividual } from "sr/utils/api/individual/getIndividual";
import { useAuth } from "app/pages/module/auth";
import { updateIndividual } from "sr/utils/api/individual/updateIndividual";
import NameChange from "./models/NameChange";
import PhoneNumberFormat from "sr/helpers/functions/PhoneNumberFormat";
import { uploadFile } from "sr/utils/api/uploadFile";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { getFiles } from "sr/utils/api/getFiles";
import { getFile } from "sr/utils/api/getFile";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import ContentLoader from "react-content-loader";
import EmailChange from "./models/EmailChange";
import { sendOTP } from "sr/utils/api/sendOTP";
import { verifyOTP } from "sr/utils/api/verifyOTP";
import { Input } from "sr/helpers";
import { toast } from "react-toastify";
import { deleteUser } from "sr/utils/api/user/deleteUser";
import {
  clearEmailVerificationPending,
  isEmailVerificationPending,
  markEmailVerificationPending,
} from "sr/helpers/functions/emailVerificationOverride";

export const Account = () => {
  const intl = useIntl();
  const [showModal, setShowModal] = useState(false);
  const [activeComponent, setActiveComponent] = useState<any>({});
  const [profileImg, setprofileImg] = useState(null);
  const [userId, setUserid] = useState();
  const [loaders, setLoaders] = useState(true);
  const { logout } = useAuth();
  const [formData, setFormData] = useState<any>({});
  const [otpSend, setOtpSend] = useState<string>("");
  const [otp, setOTP] = useState<string>("");
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [deleteAccountLoader, setDeleteAccountLoader] = useState(false);
  const HandleModel = (data) => {
    setShowModal(data);
  };
  const { loader: loader, getData: fetchData, data: data } = useGet();
  const isEmailVerified =
    data?.isEmailVerified === true &&
    !isEmailVerificationPending("individual", userId, data?.email);
  useEffect(() => {
    const { user_id } = getUserDetails();
    setUserid(user_id);
  }, []);
  const childRef = useRef(null);
  const fetchDetails = async (id) => {
    const params = new URLSearchParams();
    if (userId) params.append("id", id);
    await fetchData(() => getIndividual(params));
  };
  const HandleChange = async () => {
    let isValidData: boolean;
    if (childRef.current && childRef.current.validateData) {
      isValidData = await childRef.current.validateData();
    }
    if (childRef.current && childRef.current.submitForm) {
      childRef.current.submitForm();
    }

    if (isValidData) {
      const result = await updateIndividual({ id: userId, ...formData });
      if (result?.success === true) {
        const isEmailChanged =
          activeComponent?.label === "EmailChange" &&
          formData?.email &&
          formData.email !== data?.email;

        if (isEmailChanged) {
          markEmailVerificationPending("individual", userId, formData.email);
        }
        fetchDetails(result?.data?.id);
        setShowModal(false);
      }
    }
  };

  const handleSendOTP = async (type: "email" | "sms") => {
    setLoaders(true);
    const payload = {
      channel: type,
      username: data?.username,
    };

    try {
      const otpResult = await sendOTP(payload);
      if (otpResult?.success) {
        setOtpSend(type === "email" ? "Email" : "PhoneNo");
      }
    } catch (err) {
    } finally {
      setLoaders(false);
    }
  };

  const handleVerifyOTP = async () => {
    const payload = {
      username: data?.username,
      otp: otp,
      channel: otpSend === "Email" ? "email" : "sms",
    };

    try {
      const res = await verifyOTP(payload, { authRequired: true });
      if (res?.success) {
        if (otpSend === "Email") {
          clearEmailVerificationPending("individual", userId);
        }
        fetchDetails(userId);
        setOtpSend("");
        setOTP("");
      }
    } catch (err) {}
  };

  const handleOptOutChange = async (optOutStatus: any) => {
    if (optOutStatus !== undefined) {
      const payload = {
        id: userId,
        sms_opt_out: optOutStatus,
      };
      setLoaders(true);
      const result = await updateIndividual(payload);
      if (result?.success === true) {
        fetchDetails(userId);
        setShowModal(false);
      }
      setLoaders(false);
    }
  };

  const handleDeleteAccount = async () => {
    const reason = deleteReason.trim();
    if (!reason) {
      toast.error("Please enter your reason");
      return;
    }

    try {
      setDeleteAccountLoader(true);
      const result = await deleteUser({ reason });

      if (result?.success === true) {
        toast.success("Account deleted successfully");
        setShowDeleteAccountModal(false);
        logout();
      }
    } finally {
      setDeleteAccountLoader(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchProfileImg(userId);
      fetchDetails(userId);
    }
  }, [userId]);
  const HandleData = (data: any) => {
    setFormData(data);
  };
  const AllModels = [
    {
      label: "NameChange",
      componentName: NameChange,
      headertitle: (
        <FormattedMessage
          id="INDIVIDUAL.ACCOUNT.SETTINGS.NAME.BUTTON.TITLE"
          defaultMessage="Change Name"
        />
      ),
    },
    {
      label: "EmailChange",
      componentName: EmailChange,
      headertitle: (
        <FormattedMessage
          id="INDIVIDUAL.ACCOUNT.SETTINGS.CHANGE_EMAIL.BUTTON"
          defaultMessage="Change email"
        />
      ),
    },
    {
      label: "PasswordChange",
      componentName: PasswordChange,
      headertitle: (
        <FormattedMessage
          id="INDIVIDUAL.ACCOUNT.SETTINGS.CHANGE_PASSWORD.BUTTON"
          defaultMessage="Change password"
        />
      ),
    },
    {
      label: "ChangePhone",
      componentName: ChangePhone,
      headertitle: (
        <FormattedMessage
          id="INDIVIDUAL.ACCOUNT.SETTINGS.CHANGE_PHONENO.TITLE"
          defaultMessage="Change Phone Number"
        />
      ),
    },
  ];

  const openModel = (index: any) => {
    const activeComp = AllModels.filter(function (e, i) {
      return i == index;
    });

    setActiveComponent(activeComp[0]);

    setShowModal(true);
  };
  const HandleImage = async (e: any) => {
    setLoaders(true);
    const file: any = e.target.files[0];
    const formData = new FormData();
    formData.append("individual_id", userId);
    formData.append("profile_img", file);
    const result = await uploadFile(formData);
    if (result?.success === true) {
      setLoaders(false);
      if (profileImg) {
        SuccessMessage("API.SUCCESS.PROFILE.IMG.UPDATE");
      } else {
        SuccessMessage("API.SUCCESS.PROFILE.IMG.UPLOAD");
      }
      fetchProfileImg(userId);
    } else {
      setLoaders(false);
    }
  };
  const fetchProfileImg = async (individual_id) => {
    setLoaders(true);
    const params = {
      individual_id: individual_id,
    };
    const profileImg = await getFiles(params);
    if (profileImg?.success === true) {
      const filterfile = profileImg?.data?.filter(
        (item) => item?.file?.fieldname === "profile_img",
      );
      if (filterfile && filterfile[0]?.file?.key) {
        const fileimg = await getFile(filterfile[0]?.file?.key);
        if (fileimg) {
          const newImageUrl = URL.createObjectURL(fileimg);
          setprofileImg(newImageUrl);
          setLoaders(false);
        } else {
          setLoaders(false);
        }
      } else {
        setLoaders(false);
      }
    }
  };
  return (
    <>
      {loaders && <LoaderFullScreen />}
      <div className="flex justify-center border-b border-neutral-200 pb-3 mb-3">
        <div className="radius-50 container mx-auto my-auto flex justify-center w-[200px]">
          <label htmlFor="img-input">
            <img
              alt="Profile"
              className="rounded-full"
              src={
                profileImg
                  ? profileImg
                  : toAbsoluteUrl("/media/icons/displayProfilePlaceholder.png")
              }
            />
            <input
              onChange={(e) => HandleImage(e)}
              type="file"
              id="img-input"
              name="img"
              accept="image/*"
              className="hidden"
            ></input>
          </label>
        </div>
      </div>
      <ContentWithLoader
        loading={loader}
        content={
          <ContentLoader
            speed={2}
            width={900}
            height={500}
            viewBox="0 0 900 500"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="-590" y="17" rx="3" ry="3" width="88" height="6" />
            <rect x="-161" y="4" rx="3" ry="3" width="52" height="9" />
            <rect x="-607" y="61" rx="3" ry="3" width="410" height="9" />
            <rect x="-821" y="118" rx="3" ry="3" width="380" height="9" />
            <rect x="-647" y="90" rx="3" ry="3" width="178" height="6" />
            <circle cx="-219" cy="13" r="20" />
            <rect x="-564" y="-18" rx="3" ry="3" width="88" height="6" />
            <rect x="-266" y="202" rx="3" ry="3" width="131" height="22" />
            <rect x="-580" y="-34" rx="0" ry="0" width="4" height="40" />
            <rect x="-524" y="22" rx="0" ry="0" width="157" height="3" />
            <rect x="-460" y="73" rx="0" ry="0" width="15" height="46" />
            <rect x="-541" y="79" rx="0" ry="0" width="161" height="44" />
            <rect x="-530" y="40" rx="0" ry="0" width="165" height="55" />
            <rect x="-488" y="92" rx="0" ry="0" width="200" height="63" />
            <rect x="554" y="46" rx="0" ry="0" width="40" height="12" />
            <rect x="260" y="70" rx="0" ry="0" width="2" height="1" />
            <rect x="-715" y="125" rx="0" ry="0" width="557" height="60" />
            <rect x="-531" y="97" rx="0" ry="0" width="476" height="30" />
            <rect x="-594" y="182" rx="0" ry="0" width="373" height="128" />
            <rect x="311" y="153" rx="0" ry="0" width="0" height="21" />
            <rect x="-563" y="123" rx="0" ry="0" width="84" height="2" />
            <rect x="-637" y="124" rx="0" ry="0" width="172" height="4" />
            <rect x="-566" y="133" rx="0" ry="0" width="141" height="12" />
            <rect x="-571" y="120" rx="0" ry="0" width="60" height="5" />
            <rect x="24" y="147" rx="0" ry="0" width="2" height="12" />
            <rect x="-598" y="191" rx="0" ry="0" width="132" height="11" />
            <rect x="-558" y="139" rx="0" ry="0" width="186" height="7" />
            <rect x="-647" y="187" rx="0" ry="0" width="498" height="30" />
            <rect x="-415" y="158" rx="0" ry="0" width="72" height="8" />
            <rect x="-635" y="159" rx="0" ry="0" width="481" height="32" />
            <rect x="124" y="187" rx="0" ry="0" width="2" height="26" />
            <rect x="-238" y="170" rx="0" ry="0" width="67" height="23" />
            <rect x="23" y="11" rx="0" ry="0" width="900" height="61" />
            <rect x="25" y="88" rx="0" ry="0" width="900" height="61" />
            <rect x="27" y="166" rx="0" ry="0" width="900" height="61" />
          </ContentLoader>
        }
      >
        <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
          <div>
            <h2 className="">
              <FormattedMessage
                id="INDIVIDUAL.ACCOUNT.SETTINGS.NAME.TITLE"
                defaultMessage="Name"
              />
            </h2>
            <div>
              {data?.first_name} {data?.last_name}
            </div>
          </div>
          <div
            onClick={() => openModel(0)}
            className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
          >
            <FormattedMessage
              id="INDIVIDUAL.ACCOUNT.SETTINGS.NAME.BUTTON.TITLE"
              defaultMessage="Change Name"
            />
          </div>
        </div>
        <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
          <div>
            <h2 className="">
              <FormattedMessage
                id="INDIVIDUAL.ACCOUNT.SETTINGS.EMAIL.TITLE"
                defaultMessage="Email"
              />
            </h2>
            <div>{data?.email}</div>
            {otpSend !== "Email" && isEmailVerified && (
              <div className="text-green-600 text-sm mt-1">Verified</div>
            )}
          </div>
          <div className="flex space-x-5">
            {otpSend !== "Email" && !isEmailVerified && (
              <div
                onClick={() => handleSendOTP("email")}
                className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
              >
                <FormattedMessage
                  id="INDIVIDUAL.ACCOUNT.SETTINGS.VERIFY_EMAIL.BUTTON"
                  defaultMessage="Verify Email"
                />
              </div>
            )}
            {otpSend === "Email" && (
              <div className="flex space-x-3">
                <Input
                  onChange={(e) => setOTP(e.target.value)}
                  value={otp}
                  InputDivClass="mt-0"
                  inputClass="border border-zinc-800 rounded-lg h-11"
                />
                <div
                  onClick={handleVerifyOTP}
                  className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
                >
                  Submit
                </div>
              </div>
            )}
            <div
              onClick={() => openModel(1)}
              className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
            >
              <FormattedMessage
                id="INDIVIDUAL.ACCOUNT.SETTINGS.CHANGE_EMAIL.BUTTON"
                defaultMessage="Change email"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
          <div>
            <h2 className="">
              <FormattedMessage
                id="INDIVIDUAL.ACCOUNT.SETTINGS.PASSWORD.TITLE"
                defaultMessage="Password"
              />
            </h2>
            <div>••••••••</div>
          </div>
          <div
            onClick={() => openModel(2)}
            className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
          >
            <FormattedMessage
              id="INDIVIDUAL.ACCOUNT.SETTINGS.CHANGE_PASSWORD.BUTTON"
              defaultMessage="Change password"
            />
          </div>
        </div>
        <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
          <div>
            <h2 className="">
              <FormattedMessage
                id="INDIVIDUAL.ACCOUNT.SETTINGS.PHONENO.TITLE"
                defaultMessage="Phone number"
              />
            </h2>
            <div>{PhoneNumberFormat(data?.mobile_number)}</div>
          </div>
          <div className="flex space-x-5">
            {otpSend !== "PhoneNo" && data?.isPhoneVerified !== true && (
              <div
                onClick={() => {
                  if (
                    data?.sms_opt_out === undefined ||
                    data?.sms_opt_out === false
                  ) {
                    handleSendOTP("sms");
                  } else {
                    toast.error(
                      intl.formatMessage({
                        id: "API.ERROR.NEED.TO.DISABLE.SMSOPTOUT",
                        defaultMessage:
                          "Please Opt-In the sms to receive the otp",
                      }),
                    );
                  }
                }}
                className={`text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6]  ${
                  data?.sms_opt_out == true ? "bg-[#EEE]" : "hover:bg-[#EEF1FE]"
                } py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200 group relative`}
              >
                <FormattedMessage
                  id="INDIVIDUAL.ACCOUNT.SETTINGS.VERIFY_PHONE.BUTTON"
                  defaultMessage="Verify Phone Number"
                />

                {data?.sms_opt_out == true && (
                  <span className="absolute z-10 top-12 right-0 scale-0 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">
                    {intl.formatMessage({
                      id: "API.ERROR.NEED.TO.DISABLE.SMSOPTOUT",
                      defaultMessage:
                        "Please Opt-In the sms to receive the otp",
                    })}
                  </span>
                )}
              </div>
            )}
            {otpSend === "PhoneNo" && (
              <div className="flex space-x-3">
                <Input
                  onChange={(e) => setOTP(e.target.value)}
                  value={otp}
                  InputDivClass="mt-0"
                  inputClass="border border-zinc-800 rounded-lg h-11"
                />
                <div
                  onClick={handleVerifyOTP}
                  className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
                >
                  Submit
                </div>
              </div>
            )}
            <div
              onClick={() => openModel(3)}
              className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
            >
              <FormattedMessage
                id="INDIVIDUAL.ACCOUNT.SETTINGS.CHANGE_PHONENO.TITLE"
                defaultMessage="Change Phone Number"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
          {/* Left side */}
          <div>
            <h2 className="flex items-center gap-2">
              {/* Label */}
              <span className="whitespace-nowrap">
                <FormattedMessage
                  id="SMSOPTOUT.LABEL"
                  defaultMessage="SMS Opt out"
                />
              </span>

              {/* Info icon */}
              <div className="relative group flex-shrink-0">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-400 text-white text-xs cursor-pointer hover:bg-gray-500 transition">
                  ?
                </span>

                {/* Tooltip */}
                <div className="absolute left-0 mt-2 w-72 hidden group-hover:block bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed z-50">
                  JaniJobs sends text messages related to job applicants, work
                  order updates, supervisor updates, and more.
                  <br />
                  <br />
                  You can update this later in your account settings. Message
                  and data rates may apply.
                </div>
              </div>
            </h2>

            <div>
              {data?.sms_opt_out == true ? (
                <FormattedMessage id="SMSOPTOUT.YES" defaultMessage="Yes" />
              ) : (
                <FormattedMessage id="SMSOPTOUT.NO" defaultMessage="No" />
              )}
            </div>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-3">
            {data?.sms_opt_out === true ? (
              <div
                className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
                onClick={() => handleOptOutChange(false)}
              >
                <FormattedMessage id="BTN.TEXT.OPTIN" defaultMessage="Opt-In" />
              </div>
            ) : (
              <div
                className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
                onClick={() => handleOptOutChange(true)}
              >
                <FormattedMessage
                  id="BTN.TEXT.OPTOUT"
                  defaultMessage="Opt-Out"
                />
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
          <div>
            <h2 className="">Delete account</h2>
            <div>This will permanently delete your account.</div>
          </div>
          <div
            onClick={() => setShowDeleteAccountModal(true)}
            className="text-red-500 font-bold hover:text-red-600 hover:border-2 hover:border-red-200 hover:bg-red-50 py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
          >
            Delete account
          </div>
        </div>
        {/* <div className='flex justify-between items-center mb-3 pb-3 border-b border-neutral-200'>
        <div>
            <h2 className=''><FormattedMessage id="INDIVIDUAL.ACCOUNT.SETTINGS.AUTHENTICATION.TITLE" defaultMessage="Third party authentication" /></h2>
            <div><FormattedMessage id="INDIVIDUAL.ACCOUNT.SETTINGS.AUTHENTICATION.TEXT" defaultMessage="No third-party applications have access to your account" />
    </div>
        </div>
    </div> */}
        <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
          <div>
            <h2 className="">{data?.email}</h2>
          </div>
          <div
            onClick={() => logout()}
            className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
          >
            <FormattedMessage
              id="INDIVIDUAL.ACCOUNT.SETTINGS.SIGN_OUT.BUTTON"
              defaultMessage="Sign out"
            />
          </div>
        </div>
      </ContentWithLoader>
      <ModelWrapperWithButton
        Save={HandleChange}
        showModal={showModal}
        onCheckModel={HandleModel}
        headertitle={activeComponent.headertitle}
      >
        {
          <activeComponent.componentName
            data={data}
            HandleData={HandleData}
            ref={childRef}
            HandleModel={HandleModel}
          />
        }
      </ModelWrapperWithButton>
      <ModelWrapperWithButton
        Save={handleDeleteAccount}
        showModal={showDeleteAccountModal}
        onCheckModel={setShowDeleteAccountModal}
        headertitle="Delete account"
        savetext={deleteAccountLoader ? "Deleting..." : "Delete account"}
      >
        <div>
          <p className="mb-4">
            Are you sure you want to delete your account? This action cannot be
            undone.
          </p>
          <label className="block font-bold mb-2">Reason</label>
          <textarea
            value={deleteReason}
            onChange={(e) => setDeleteReason(e.target.value)}
            placeholder="Enter your reason"
            className="w-full min-h-[120px] border border-neutral-300 rounded-lg p-3"
          />
        </div>
      </ModelWrapperWithButton>
    </>
  );
};
